<template>
  <div class="custom-landing-page" :style="customStyle">
    <el-tabs v-model="activePageNum" class="page-tab" @tab-click="handlePageTabClick(false)">
      <el-tab-pane
        v-for="tab in tabList"
        :key="tab.pageNum"
        :label="tab.label"
        :name="tab.pageNum">
      </el-tab-pane>
    </el-tabs>
    <div class="device-and-language-container">
      <!-- 职位列表页面不显示设备的切换 -->
      <div v-if="CUSTOM_LANDING_PAGE_TYPE.JOB_LIST !== activeDeviceNum" class="device">
        <div class="mobile device-item" :class="activeDeviceNum === DEVICE_PAGE_NUM_MAP[activeDeviceNum].mobile && 'active'" @click="changeDevice(DEVICE_PAGE_NUM_MAP[activeDeviceNum].mobile)">{{ $t(`${i18nPrefix}.label.mobile`) }}</div>
        <div class="pc device-item" :class="activeDeviceNum === DEVICE_PAGE_NUM_MAP[activeDeviceNum].pc && 'active'" @click="changeDevice(DEVICE_PAGE_NUM_MAP[activeDeviceNum].pc)">{{ $t(`${i18nPrefix}.label.pc`) }}</div>
      </div>
      <div class="language">
        <div class="english language-item" :class="activeLanguage === LANGUAGE_TYPE.ZH && 'active'" @click="changeLanguage(LANGUAGE_TYPE.ZH)">中文</div>
        <div class="chinese language-item" :class="activeLanguage === LANGUAGE_TYPE.EN && 'active'" @click="changeLanguage(LANGUAGE_TYPE.EN)">English</div>
      </div>
    </div>
    <div v-if="activeMsg" class="activated-msg">{{ activeMsg }}</div>
    <Content v-if="customSetting" ref="content" :pageNum="activePageNum" :customSetting="customSetting" />
    <div class="footer-btn-group adapt-wrapper">
      <el-button class="footer-btn cancel-btn grey-btn" @click="handleCancel">{{ $t('common.btn.cancel') }}</el-button>
      <el-button v-if="showPreviewBtn" class="footer-btn preview-btn blue-btn" @click="handlePreview">{{ $t('common.btn.preview') }}</el-button>
      <el-button class="footer-btn save-btn blue-btn" @click="handleSave">{{ $t('common.btn.save') }}</el-button>
    </div>
    <MobilePreviewDIalog v-if="customSetting" :show.sync="showMobilePreviewDialog" :customSetting="previewCustomSetting" :otherCustomSetting="otherCustomSetting"></MobilePreviewDIalog>
  </div>
</template>

<script>
import { CUSTOM_LANDING_PAGE_TYPE, DEVICE_PAGE_NUM_MAP, MOBILE_PAGE_NUM_MAP } from '@/constant/company'
import Content from './components/content.vue'
import MobilePreviewDIalog from './components/mobilePreviewDialog.vue'
import { mapActions } from 'vuex'
import _ from 'lodash'

const LANGUAGE_TYPE = {
  ZH: 'zh-cn',
  EN: 'en'
}

export default {
  components: {
    Content,
    MobilePreviewDIalog
  },
  data () {
    return {
      LANGUAGE_TYPE,
      DEVICE_PAGE_NUM_MAP,
      CUSTOM_LANDING_PAGE_TYPE,
      activePageNum: null,
      activeDeviceNum: null,
      i18nPrefix: 'admin.company.customLandingPage',
      customSetting: null,
      previewCustomSetting: null,
      otherCustomSetting: null,
      showMobilePreviewDialog: false,
      customStyle: null
    }
  },
  computed: {
    showPreviewBtn () {
      return CUSTOM_LANDING_PAGE_TYPE.JOB_LIST !== this.activeDeviceNum && this.activeDeviceNum === DEVICE_PAGE_NUM_MAP[this.activeDeviceNum].mobile
    },
    tabList () {
      const i18nPrefix = this.i18nPrefix

      const list = [
        {
          pageNum: CUSTOM_LANDING_PAGE_TYPE.COMPANY_INFO,
          label: this.$t(`${i18nPrefix}.label.companyInfo`)
        },
        {
          pageNum: CUSTOM_LANDING_PAGE_TYPE.TEAM_INFO,
          label: this.$t(`${i18nPrefix}.label.teamInfo`)
        },
        {
          pageNum: CUSTOM_LANDING_PAGE_TYPE.JOB_LIST,
          label: this.$t(`${i18nPrefix}.label.wechatShareJobList`)
        },
        {
          pageNum: CUSTOM_LANDING_PAGE_TYPE.EMPLOYEE_COMPANY_INFO,
          label: this.$t(`${i18nPrefix}.label.employeeCompanyInfo`)
        },
        {
          pageNum: CUSTOM_LANDING_PAGE_TYPE.EMPLOYEE_TEAM_INFO,
          label: this.$t(`${i18nPrefix}.label.employeeTeamInfo`)
        }
      ]
      return list
    },
    activeLanguage () {
      return this.$route.query.language
    },
    activeMsg () {
      // 手机端信息页展示
      let i18nKey = ''
      if (this.routePageNum === CUSTOM_LANDING_PAGE_TYPE.TEAM_INFO) {
        i18nKey = 'isActivatedPage2Msg'
      } else if (this.routePageNum === CUSTOM_LANDING_PAGE_TYPE.EMPLOYEE_TEAM_INFO) {
        i18nKey = 'isActivatedPage6Msg'
      }

      return i18nKey && this.$t(`${this.i18nPrefix}.label.${i18nKey}`)
    },
    routePageNum () {
      return this.$route.query.page_num
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    ...mapActions('company', ['getCustomLandingPageInfo', 'updateCustomLandingPageInfo']),
    initPage (initQuery) {
      let query = initQuery
      if (!initQuery) {
        const pageNum = this.routePageNum || CUSTOM_LANDING_PAGE_TYPE.COMPANY_INFO
        const language = this.activeLanguage || LANGUAGE_TYPE.ZH
        query = {
          page_num: pageNum,
          language
        }
      }

      this.getPageInfo(query)
      this.getOtherPageInfo(query)
      this.updateQuery(query)
    },
    handlePageTabClick (isDeviceTabClick) {
      const pageNum = isDeviceTabClick ? this.activeDeviceNum : this.activePageNum
      const query = {
        page_num: pageNum,
        language: this.activeLanguage
      }
      if (this.routePageNum === pageNum) {
        return
      }
      this.updateQuery(query)
      this.getPageInfo(query)
      this.getOtherPageInfo(query)
    },
    updateQuery (query) {
      this.activePageNum = DEVICE_PAGE_NUM_MAP[query.page_num]?.mobile
      this.activeDeviceNum = query.page_num
      const needUpdate = !_.isEqual(query, this.$route.query)
      if (!needUpdate) {
        return
      }
      this.$router.push({ query })
    },
    async getPageInfo (query) {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.getCustomLandingPageInfo({
          pageNum: query.page_num,
          params: { language: query.language }
        })
        if (!resp) {
          return
        }
        this.customSetting = resp
        this.customStyle = {
          '--custom-color': resp.company.custom_color
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async getOtherPageInfo (query) {
      const mobilePageNumList = _.values(MOBILE_PAGE_NUM_MAP)
      if (!mobilePageNumList.includes(query.page_num)) {
        return
      }
      const resp = await this.getCustomLandingPageInfo({
        pageNum: MOBILE_PAGE_NUM_MAP[query.page_num],
        params: { language: query.language }
      })
      if (!resp) {
        return
      }
      this.otherCustomSetting = resp
    },
    /**
     * 手机端预览
     */
    async handlePreview () {
      this.$eventBus.$emit('showLoading', true)
      try {
        const valid = await this.$refs.content.submit()
        if (!valid) {
          return
        }
        this.previewCustomSetting = this.formatData()
        this.showMobilePreviewDialog = true
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async handleSave () {
      this.$eventBus.$emit('showLoading', true)
      try {
        const valid = await this.$refs.content.submit()
        if (!valid) {
          return
        }
        const resp = await this.submit()
        if (resp) {
          this.$message.success(this.$t('common.message.saveSuccess'))
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handleCancel () {
      this.$router.go(0)
    },
    async submit () {
      const data = this.formatData()
      return await this.updateCustomLandingPageInfo({
        pageNum: this.routePageNum,
        data
      })
    },
    formatData () {
      const companyWebPageSetting = this.customSetting.company_webpage_setting
      const data = {
        ...this.customSetting,
        language: this.activeLanguage,
        company_webpage_setting: {
          ...companyWebPageSetting,
          pc_branding_banner: this.customSetting.pcBrandingBanner,
          items: _.map(this.customSetting.customContentList, (item, index) => ({ ...item, order: index })),
          video_navigation_list: _.filter(this.customSetting.videoNavigationList?.video_list, item => { return item.url })
        }
      }
      return data
    },
    changeLanguage (language) {
      const query = {
        ...this.$route.query,
        language
      }
      this.initPage(query)
    },
    changeDevice (deviceNum) {
      this.activeDeviceNum = deviceNum
      this.handlePageTabClick(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-landing-page {
  background: #fff;
  min-height: 100%;
  font-size: 12px;
  border-radius: 4px;
  margin-top: 15px;

  .title {
    margin-bottom: 20px;
    font-size: 13px;
    color: #000;
  }

  .tab-container {
    display: flex;

    .page-tab {
      flex: 1;
    }
  }

  .device-and-language-container {
    width: 680px;
    margin: 15px auto 0;
    font-size: 14px;
    display: flex;

    .language,
    .device {
      display: flex;
      line-height: 1;

      &.language {
        margin-left: auto;
      }

      .language-item,
      .device-item {
        cursor: pointer;

        &:last-child {
          margin-left: 12px;
          padding-left: 12px;
          border-left: 1px solid #ddd;
        }

        &.active {
          color: #0096cc;
        }
      }
    }
  }

  .activated-msg {
    width: 680px;
    margin: 10px auto 0;
    font-size: 12px;
    color: #999;
  }

  .footer-btn-group {
    width: 680px;
    margin: 60px auto 0;
    display: flex;
    justify-content: space-between;

    .footer-btn {
      padding: 5px 25px;
      line-height: normal;

      &.cancel-btn {
        margin-right: auto;
      }
    }
  }
}
</style>
